/* Shared language registry for all AllBaise hubs — 33 languages.
 * Group order: Global (top, popular first) → African → Mzansi
 * Smart Talk is canonical; all other hubs must import from here.
 */

export const SMART_TALK_LANGUAGES = [
  // GLOBAL LANGUAGES (popular first)
  { code: "en", name: "English", group: "Global", flag: "🌐" },
  { code: "es", name: "Spanish", group: "Global", flag: "🇪🇸" },
  { code: "fr", name: "French", group: "Global", flag: "🇫🇷" },
  { code: "pt", name: "Portuguese", group: "Global", flag: "🇵🇹" },
  { code: "de", name: "German", group: "Global", flag: "🇩🇪" },
  { code: "it", name: "Italian", group: "Global", flag: "🇮🇹" },
  { code: "nl", name: "Dutch", group: "Global", flag: "🇳🇱" },
  { code: "ar", name: "Arabic", group: "Global", flag: "🇸🇦" },
  { code: "zh", name: "Mandarin Chinese", group: "Global", flag: "🇨🇳" },
  { code: "ru", name: "Russian", group: "Global", flag: "🇷🇺" },
  { code: "hi", name: "Hindi", group: "Global", flag: "🇮🇳" },
  { code: "ur", name: "Urdu", group: "Global", flag: "🇵🇰" },
  { code: "fa", name: "Farsi/Persian", group: "Global", flag: "🇮🇷" },
  { code: "he", name: "Hebrew", group: "Global", flag: "🇮🇱" },

  // AFRICAN LANGUAGES
  { code: "sw", name: "Kiswahili", group: "African", flag: "🇹🇿" },
  { code: "ha", name: "Hausa", group: "African", flag: "🇳🇬" },
  { code: "yo", name: "Yoruba", group: "African", flag: "🇳🇬" },
  { code: "ig", name: "Igbo", group: "African", flag: "🇳🇬" },
  { code: "am", name: "Amharic", group: "African", flag: "🇪🇹" },
  { code: "om", name: "Oromo", group: "African", flag: "🇪🇹" },
  { code: "sn", name: "Shona", group: "African", flag: "🇿🇼" },
  { code: "mg", name: "Malagasy", group: "African", flag: "🇲🇬" },

  // MZANSI (South African Official Languages)
  { code: "zu", name: "isiZulu", group: "Mzansi", flag: "🇿🇦" },
  { code: "xh", name: "isiXhosa", group: "Mzansi", flag: "🇿🇦" },
  { code: "af", name: "Afrikaans", group: "Mzansi", flag: "🇿🇦" },
  { code: "st", name: "Sesotho", group: "Mzansi", flag: "🇿🇦" },
  { code: "tn", name: "Setswana", group: "Mzansi", flag: "🇿🇦" },
  { code: "nso", name: "Sepedi", group: "Mzansi", flag: "🇿🇦" },
  { code: "ts", name: "Xitsonga", group: "Mzansi", flag: "🇿🇦" },
  { code: "ve", name: "Tshivenda", group: "Mzansi", flag: "🇿🇦" },
  { code: "nr", name: "isiNdebele", group: "Mzansi", flag: "🇿🇦" },
  { code: "ss", name: "siSwati", group: "Mzansi", flag: "🇿🇦" },
];

// Flat code-name options for transcription selectors (Transcribe, TranscriptionB, etc.)
export const LANGUAGE_OPTIONS = SMART_TALK_LANGUAGES.map(l => ({ code: l.code, name: l.name }));

// Grouped codes for grouped selectors — ordered: Global, African, Mzansi
export const LANG_GROUPS = SMART_TALK_LANGUAGES.reduce((acc, l) => {
  if (!acc[l.group]) acc[l.group] = [];
  acc[l.group].push(l.code);
  return acc;
}, {});

// Display names by code
export const LANG_NAMES = SMART_TALK_LANGUAGES.reduce((acc, l) => {
  acc[l.code] = l.name;
  return acc;
}, {});

// Flags by code
export const LANG_FLAGS = SMART_TALK_LANGUAGES.reduce((acc, l) => {
  acc[l.code] = l.flag;
  return acc;
}, {});

// Translation target language names (used by Transcribe, Translate, etc.)
export const TRANSLATE_LANGUAGES = SMART_TALK_LANGUAGES.map(l => l.name);

// Group colors for styled group headers in selectors
export const GROUP_COLORS = {
  Global: { bg: "bg-blue-600/20", text: "text-blue-400", border: "border-blue-600/30" },
  African: { bg: "bg-amber-600/20", text: "text-amber-400", border: "border-amber-600/30" },
  Mzansi: { bg: "bg-green-600/20", text: "text-green-400", border: "border-green-600/30" },
};
